namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmDatovaSchranka extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmDatovaSchrankaReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmDatovaSchrankaObj & GContent;
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmDatovaSchrankaObj());
            this.detailObj.createBase({
                contentName: "detailAdmDatovaSchranka",
                contentCaption: "jres:33000646", //RC 33000646 : Datov� schr�nka
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false) {
                tabs.push(this.detailObj.getAutomatickeMotoryTab());
                tabs.push(this.detailObj.getAuditPristupuTab());
            }
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false) {
                groups.push(this.detailObj.getAutomatickeMotoryGroup());
                groups.push(this.detailObj.getAuditPristupuGroup());
            }
            builder.withComponent<this>("DetailAdmDatovaSchranka", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmDatovaSchrankaObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmDatovaSchrankaReadDto> {
        private srv: GContent;

        private getSrv(): GContent {
            if (!this.srv)
                this.srv = this.cnt.createServiceContent("Gordic.Adm.WebControls.DetailAdmDatovaSchranka");
            return this.srv;
        }

        create() {

        }

        textPopis(): string | undefined | null {
            return this.data["mailbox"]
        }

        setSxsDetail(): string {
            return (this.data.mailbox) ? this.data.mailbox : "";
        }

        saveBase(close: boolean) {
            this.hideAllFlash();
            var form = this.cnt.findForms("{0}form".format(this.options.contentName));
            var novaData: any = {};
            form.gform("waitForValues").done(() => {
                if (form.gform("isValid")) {
                    return Prefabs.GStringBox.updateChiperPublicKeys(form).then(() => {
                        form.findFields().gfield("model", "collect", novaData);
                        this.saveData(novaData, close);
                    })
                }
            })
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmDatovaSchrankaSaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            if (data.NewRecord == true)
                data.change_passwd = 10;
            this.getSrv().call("SaveDatovaSchranka", { datovaSchranka: data }).done((output) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase().done(() => {
                        this.showSuccessSave(close);
                        if (close == true) {
                            this.closeAction(true).done(() => { this.cnt.close() });
                        } else
                            this.reloadDataBase();
                    })
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                this.pendingAction("actSave", false)
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmDatovaSchranka", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.AdmDatovaSchranka.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} - {1}".format(this.options.contentCaption, (this.data.mailbox) ? this.data.mailbox : "");
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        setEditMode(editMode: boolean) {
            if (this.options.newRecord == false) {
                this.cnt.findFields("zpusob_ulozeni_hesla").gfield("disable")
                this.cnt.findFields("pdb1").gfield("disable")
                this.cnt.findFields("pdb2").gfield("disable")
                this.cnt.findFields("password_map").gfield("disable")
            }
        }

        createForm() {
            this.form.form.layoutDescriptor = "L2M2S1";
            this.MakeSection("jres:33000647") //RC 33000647 : Z�kladn� informace
            this.MakeSelectField("ico", Gordic.Prefabs.Select.ginsico(), {
                flag: this.createFlagNemenne(),
                model: "model.ico=value.ico"
            });
            this.MakeField("mailbox", {
                flag: this.createFlagNemenne()
            });
            this.MakeSelectField("typ_mbx", Gordic.Prefabs.Select.gincmbx(), {
                model: "model.typ_mbx=value.typ_mbx",
                flag: this.createFlagNemenne(),
                serverFilters: { typ_mbx: [30, 50] },
            });
            this.MakeField("nazev");
            this.MakeField("poznamka");
            this.MakeBoolField("priz_master");
            this.MakeBoolField("priz_automat");
            this.MakeBoolField("priz_findbx");
            this.MakeBoolField("priz_send_only");


            this.MakeSection("jres:32131158") //RC 32131158 : Parametry p�ihl�en�
            this.MakeSelectField("typ_aute", Gordic.Prefabs.Select.gincaut(), {
                model: "model.typ_aute=value.typ_aute",
                change: (ev, changeObj) => {
                    var form = this.cnt.findForms("FormAdmDatovaSchrankaService");
                    var no_exp = form.findFields("no_exp");
                    this.HideField("ixs_cer");
                    this.HideField("ldb");
                    this.HideField("change_passwd");
                    this.HideField("no_exp");
                    this.HideField("dat_chpasswd");
                    this.HideField("dat_exp");
                    this.HideField("pdb1");
                    this.HideField("pdb2");
                    this.HideField("zpusob_ulozeni_hesla");
                    var expireDat = no_exp.gfield("getValue");
                    if (changeObj.value) {
                        if (!Array.isArray(changeObj.value)) {
                            if (changeObj.value.typ_aute == 0) {
                                this.ShowField("ldb");
                                this.ShowField("change_passwd");
                                this.ShowField("no_exp");
                                this.ShowField("dat_chpasswd");
                                this.ShowField("zpusob_ulozeni_hesla");
                                this.ShowField("pdb1");
                                this.ShowField("pdb2");
                                if (expireDat == true)
                                    this.ShowField("dat_exp");
                                this.hesloOpenFields();
                            } else if (changeObj.value.typ_aute == 20) {
                                this.ShowField("ixs_cer");
                            } else {
                                this.ShowField("ixs_cer");
                                this.ShowField("ldb");
                                this.ShowField("change_passwd");
                                this.ShowField("no_exp");
                                this.ShowField("dat_chpasswd");
                                this.ShowField("zpusob_ulozeni_hesla");
                                this.ShowField("pdb1");
                                this.ShowField("pdb2");
                                if (expireDat == true)
                                    this.ShowField("dat_exp");
                                this.hesloOpenFields();
                            }
                        }
                    }
                }
            });
            this.MakeSelectField("ixs_cer", Gordic.Prefabs.Select.wflscer(), { model: "model.ixs_cer=value.ixs_cer" })
            this.MakeField("login_txt");
            if (this.options.newRecord == false) {
                this.MakeBool10Field("change_passwd", {
                    change: (ev, obj) => {
                        var form = this.cnt.findForms("{0}form".format(this.options.contentName))
                        var pdb1 = form.findFields("pdb1")
                        var pdb2 = form.findFields("pdb2")
                        var zpusob = form.findFields("zpusob_ulozeni_hesla")
                        var map = form.findFields("password_map")
                        if (obj.value == true) {
                            pdb1.gfield("enable")
                            pdb2.gfield("enable")
                            zpusob.gfield("enable")
                            map.gfield("enable")
                        } else {
                            pdb1.gfield("disable")
                            pdb2.gfield("disable")
                            zpusob.gfield("disable")
                            map.gfield("disable")
                        }
                    }
                });
            }
            this.form.addRow({ label: "jres:33000631", name: "zpusob_ulozeni_hesla" }).addField("gradio", {
                name: "zpusob_ulozeni_hesla",
                disabled: !this.editMode,
                itemClass: "w-12",
                radios: [
                    { value: 0, label: "jres:33000632" }, //RC 33000632 : Datab�ze
                    { value: 10, label: "jres:33000633" }, //RC 33000633 : P��m� mapov�n�
                    { value: 20, label: "jres:33000634" } //RC 33000634 : Nep��m� mapov�n�
                ],
                change: (ev, ctx) => {
                    this.hesloOpenFields();
                }
            })
            this.form.addRow({ label: "jres:30028702", name: "pdb1_row" }).addField("gstringbox", Gordic.Prefabs.GStringBox.password({
                obslouzilJsemSbiraniHodnotZPolicekTakAbyNemohlNastatProblemSNeaktualnimSifrovacimKlicem: true
            }), {
                name: "pdb1",
                disabled: !this.editMode,
                validators: [this.createSpecialValidator()],
                tag: {
                    text: "jres:33000289", 
                    state: "info"
                }
            })
            this.form.addRow({ label: "jres:33000406", name: "pdb2_row" }).addField("gstringbox", Gordic.Prefabs.GStringBox.password({ //RC 33000406 : Heslo znovu
                obslouzilJsemSbiraniHodnotZPolicekTakAbyNemohlNastatProblemSNeaktualnimSifrovacimKlicem: true
            }), {
                name: "pdb2",
                disabled: !this.editMode,
                tag: {
                    text: "jres:33000289",
                    state: "info"
                }
            })
            this.form.addRow({ label: "jres:33000635", name: "password_map_row" }).addField("gstringbox", {
                name: "password_map",
                disabled: !this.editMode,
                flag: "required",
                tag: {
                    text: "jres:33000644", //RC 33000644 : Sem nezad�vejte heslo ale pouze informaci, kde je heslo ulo�eno (odkaz, identifik�tor)!
                    state: "warning"
                }
            })
            this.MakeField("dat_chpasswd");
            this.MakeSelectField("noexp", Gordic.Prefabs.Select.gincpan(), {
                model: "model.noexp=value.priz_an",
                change: (ev, obj) => {
                    if (!Array.isArray(obj.value)) {
                        if (obj.value != null) {
                            if (obj.value.priz_an == 1) {
                                this.HideField("dat_exp");
                            } else
                                this.ShowField("dat_exp");
                        }
                    }
                }
            })
            this.MakeField("dat_exp");


            this.MakeSection("jres:32131157") //RC 32131157 : Spisov� uzel - Vlastn�k / Spr�vce
            this.MakeSelectField("ixs_su", Gordic.Prefabs.Select.ginspod(), { model: "model.ico=>value.ico,model.ixs_su=value.ixs_su", serverFilters: { aktivita: null, ico: new Gordic.Forms.Dependency("ico", "ico", true, false, this.cnt.element) }, dropdown: false });        // vlastn�k sch�nky
            // schr�nka je spravov�na nad��zen�m spisov�m uzlem ( je ur�en tabulkou ginvmbx - um�l� polo�ka ixs_su_main )
            // 1 - spravuje vlastnik shranky - potom se ixs_su_main nezad�v�
            // 0 - spravuje zadan� spisov� uzel
            this.MakeSelectField("priz_main", Gordic.Prefabs.Select.gincpan(), {
                model: "model.priz_main=value.priz_an",
                change: (ev, obj) => {
                    if (!Array.isArray(obj.value)) { 
                        if (obj.value != null) {
                            if (obj.value.priz_an == 1)
                                this.HideField("ixs_su_main");
                            else
                                this.ShowField("ixs_su_main");
                        }
                    }
                }
            })
            this.MakeSelectField("ixs_su_main", Gordic.Prefabs.Select.ginspod(), { model: "model.ico=>value.ico,model.ixs_su_main=value.ixs_su", serverFilters: { aktivita: null, ico: new Gordic.Forms.Dependency("ico", "ico", true, false, this.cnt.element) }, dropdown: false });       // kdo ovl�d� schr�nku - m��e b�t jin� ne� vlastn�k schr�nky - v�t�inou se jedn� o nad��zen� spisov� uzel ( podatelna )
            if (this.options.newRecord == false) {
                this.MakeSection("jres:33000012") //RC 33000012 : Ochrann� prvky - schr�nka byla vytvo�ena a je povolena pouze pro uvedenou datab�zi
                this.MakeField("db_name");
                this.MakeField("typ_db");
                this.MakeField("servername32");
            }


            this.MakeSection("jres:29924152")
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt(), { model: "model.aktivita=value.aktivita" });
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
            if (this.data.priz_main == 0)
                this.ShowField("ixs_su_main");
        }

        private createSpecialValidator(): Gordic.Validators.Base {
            var validator = new Gordic.Validators.Base({ message: "jres:33000252" })
            validator.stopping = true;
            validator.validate = (value, source) => {
                var form = this.cnt.findForms("{0}form".format(this.options.contentName));
                var changePasswd = form.findFields("change_passwd").gfield("getValue")
                var pdb1 = form.findFields("pdb1").gfield("getValue");
                var pdb2 = form.findFields("pdb2").gfield("getValue");
                if (changePasswd == true) {
                    if (pdb1 == pdb2)
                        return true
                    else
                        return false
                } else return true
            }
            return validator;
        }

        private hesloOpenFields() {
            var zpusobUlozeniHesla = this.cnt.findFields("zpusob_ulozeni_hesla").gfield("getValue");
            this.cnt.findFields("password_map").gfield("setValidators", []);
            this.HideField("pdb1")
            this.HideField("pdb2")
            this.HideField("password_map")
            if (zpusobUlozeniHesla == 0) {
                this.ShowField("pdb1")
                this.ShowField("pdb2")
            } else if (zpusobUlozeniHesla == 20) {
                this.ShowField("password_map")
                this.cnt.findFields("password_map").gfield("setValidators", [new Gordic.Validators.Required({ stopping: true })])
            }
        }

        getAutomatickeMotoryTab(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-automaticke-motory-epa",
                    title: "jres:33001024",
                    opened: true,
                    locked: true,
                    group: { id: "_tab-automaticke-motory-epa" }
                },
                contentParams: {
                    className: "Gordic.Adm.WebControls.SeznamAdmMotorZpracovaniEPA",
                    serverParams: {
                        ID: "SeznamAdmMotorZpracovaniEPA",
                        mailbox: this.data.mailbox,
                        typ_mbx: this.data.typ_mbx,
                        tabOpen: true
                    }
                }
            }
        }

        getAutomatickeMotoryGroup(): IGTabGroupOptions {
            return { id: "_tab-automaticke-motory-epa", caption: "jres:33001024" }
        }
    }
}
